import { Toast } from "flowbite-react";
import Dashboard from "../../common/components/layout/Dashboard";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableProduct from "./components/table-products/TableProduct";

function ProductRegisterPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableProduct />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default ProductRegisterPage;